import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const dropzone = style(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: themeVars.space['150'],
    padding: themeVars.space['400'],
    border: `${themeVars.border['width-0125']} dashed ${themeVars.color['border-base']}`,
    borderRadius: themeVars.radius['4'],
    backgroundColor: themeVars.color['surface-base'],
    textAlign: 'center',
  },
  'file-input-dropzone',
);

export const dragActive = style(
  {
    borderColor: themeVars.color['border-accent'],
    backgroundColor: themeVars.color['surface-accent'],
  },
  'file-input-drag-active',
);

export const disabled = style(
  {
    opacity: 0.6,
    pointerEvents: 'none',
  },
  'file-input-disabled',
);

export const hiddenInput = style(
  {
    display: 'none',
  },
  'file-input-hidden-input',
);
